<template>
  <keep-alive>
    <component :is="svg" />
  </keep-alive>
</template>

<script>
import { kebabToPascal } from '@/utils/general'
import icons from '@/assets/icons'

const components = {}

icons.forEach((icon) => {
  components[kebabToPascal(icon)] = require(`@/assets/svg/${icon}.svg`)
})

export default {
  name: 'OSvg',
  components,
  props: {
    svg: {
      type: String,
      required: true
    }
  }
}
</script>
